import type { ActivityModule } from '../../core/activity';
import { mountClockgame } from './ui';
import levelsData from './levels.json';
import './style.css';

export const clockgame: ActivityModule = {
  id: 'clockgame',
  title: 'Aprender o relógio',
  description: 'Marque o horário pedido no relógio analógico. Ajuste os ponteiros de hora, minuto e segundo.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/clockgame/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountClockgame,
};
